export { default } from './FormPageEventOrganizer.vue'
